import React from 'react';

export default function SOPVersionChanges({ changesStr }) {
  let changes;
  try {
    changes = typeof changesStr === 'string' ? JSON.parse(changesStr) : changesStr;
  } catch {
    return <pre className='sop-version-pre mb-0'>{changesStr}</pre>;
  }
  if (!changes || typeof changes !== 'object') return null;

  // Helper to render a list of items
  const renderScopeList = (items) => (
    <ul style={{ margin: 0, paddingLeft: 18 }}>
      {items.map((item, idx) => (
        <li key={item.trim() + idx}>{item.trim()}</li>
      ))}
    </ul>
  );

  const renderNotesList = (items) => (
    <ul style={{ margin: 0, paddingLeft: 18 }}>
      {items.map((note, index) => {
        const parts = note.split(' -> ');
        if (parts.length < 3) {
          return <li key={index}>{note}</li>; // Fallback for wrong format
        }
        const [oldVal, newVal, tradeName] = parts;
        const oldText = oldVal.trim() === '' ? 'NA' : oldVal;
        const newText = newVal.trim() === '' ? 'NA' : newVal;

        return (
          <li key={index}>
            <b>{tradeName.trim()}:</b> {oldText} → {newText}
          </li>
        );
      })}
    </ul>
  );

  return (
    <div className='sop-version-changes'>
      {changes.trades_added && changes.trades_added.length > 0 && (
        <div><b>Trades Added:</b> {renderScopeList(changes.trades_added)}</div>
      )}
      {changes.trades_removed && changes.trades_removed.length > 0 && (
        <div><b>Trades Removed:</b> {renderScopeList(changes.trades_removed)}</div>
      )}
      {changes.scope_items_updated && Object.keys(changes.scope_items_updated).length > 0 && (
        <div className='mt-1'>
          <b>Scope Items Updated:</b>
          <ul style={{ margin: 0, paddingLeft: 18 }}>
            {Object.entries(changes.scope_items_updated).map(([trade, { added, removed }]) => (
              <li key={trade}>
                <b>{trade}</b>
                <ul style={{ margin: 0, paddingLeft: 18 }}>
                  {added && added.length > 0 && (
                    <li><span style={{ color: '#228B22' }}>Added:</span> {renderScopeList(added)}</li>
                  )}
                  {removed && removed.length > 0 && (
                    <li><span style={{ color: '#B22222' }}>Removed:</span> {renderScopeList(removed)}</li>
                  )}
                </ul>
              </li>
            ))}
          </ul>
        </div>
      )}
      {changes.notes_edited && (
        <div className='mt-1'>
          <b>Notes Edited:</b> 
          {changes.notes_edited.length > 0 ? renderNotesList(changes.notes_edited) : ' N/A'}
        </div>
      )}
    </div>
  );
} 